import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";
import EncoreWordmark from "../components/EncoreWordmark";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6 spotlight"
    >
      <div className="w-full max-w-md border border-white/10 bg-stone-900/60 backdrop-blur-xl p-10">
        <EncoreWordmark size="card" className="mb-6" />
        <div className="flex items-center gap-3 mb-2">
          <Lock size={18} className="text-[#DE9E48]" />
          <p className="font-overline text-xs text-[#DE9E48]">— Admin Access</p>
        </div>
        <h1 className="font-display text-3xl md:text-4xl mb-2">
          Sign in to the Admin Console
        </h1>
        <p className="font-body text-stone-400 text-sm mb-8">
          Manage gallery, articles, and contact messages.
        </p>

        <form onSubmit={submit}>
          <div className="mb-6">
            <label className="field-label">Username</label>
            <input
              data-testid="login-username"
              required
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="field-input"
              placeholder="admin"
            />
          </div>
          <div className="mb-8">
            <label className="field-label">Password</label>
            <input
              data-testid="login-password"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
              placeholder="••••••••"
            />
          </div>

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="btn-gold w-full justify-center disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>

          {error && (
            <p
              data-testid="login-error"
              className="mt-6 font-overline text-xs text-red-400 text-center"
            >
              ✕ {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
